import { OnboardingChapter } from '../../../../../pure-js/enums/OnboardingChapter'

export const ASSESSMENT_TOTAL_QUESTIONS = 37

interface AssessmentProgressInput {
  currentQuestion?: number
  completedSteps?: OnboardingChapter[]
  totalQuestions?: number
}

export const deriveAssessmentAnsweredCount = ({
  currentQuestion,
  completedSteps,
  totalQuestions = ASSESSMENT_TOTAL_QUESTIONS
}: AssessmentProgressInput): number => {
  const hasCompletedAssessment = completedSteps?.includes(OnboardingChapter.Assessment)
  if (hasCompletedAssessment) {
    return totalQuestions
  }

  if (typeof currentQuestion !== 'number') {
    return 0
  }

  const answeredCount = currentQuestion - 1

  if (answeredCount <= 0) {
    return 0
  }

  return Math.min(answeredCount, totalQuestions)
}

export const hasAssessmentInProgress = (input: AssessmentProgressInput): boolean => {
  return deriveAssessmentAnsweredCount(input) > 0
}
